import axios from "axios";

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("satish_admin_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export const qrUrl = (data, filename = "qr-code", download = false) =>
  `${API}/qr?data=${encodeURIComponent(data)}&filename=${encodeURIComponent(filename)}${download ? "&download=true" : ""}`;
